import React, { useState } from 'react';
import { Modal } from 'antd';
export default function ApplyModal(props) {
    var isVisible = props.isVisible, isInsideApp = props.isInsideApp, trialDays = props.trialDays, onOk = props.onOk;
    var _a = useState(isVisible), visible = _a[0], setVisible = _a[1];
    return (React.createElement(Modal, { title: "\u514D\u8D39\u8BD5\u7528\u987B\u77E5", cancelText: "\u53D6\u6D88", okText: "\u7533\u8BF7\u8BD5\u7528", visible: visible, onOk: function () {
            onOk();
            setVisible(false);
        }, onCancel: function () {
            setVisible(false);
        }, width: 360, style: { top: '30%' } },
        React.createElement("p", null,
            "\u8BE5",
            isInsideApp ? '功能' : '应用',
            "\u5C5E\u4E8E\u4ED8\u8D39\u9879\u76EE\uFF0C\u63D0\u4F9B",
            trialDays ? Math.ceil(trialDays / 30) + "\u4E2A\u6708\u7684" : '一定时长',
            "\u514D\u8D39\u8BD5\u7528\u670D\u52A1\uFF0C\u60A8\u53EF\u4EE5\u70B9\u51FB\u201C\u7533\u8BF7\u8BD5\u7528\u201D\u53D1\u8D77\u8BD5\u7528\u7533\u8BF7\u3002"),
        React.createElement("p", null, "\u5982\u6709\u4EFB\u4F55\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D400-615-1212\u3002")));
}
//# sourceMappingURL=ApplyModal.js.map